// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3271":"css/admin-app.6694","4543":"css/app.6694"}[chunkId] + ".css";
};